import mergeClassNames from "common/mergeClassNames";
import React from "react";

interface IFlexContainerLayoutProps extends React.HTMLProps<HTMLDivElement> {
    children: React.ReactNode;
    footer?: React.ReactNode;
    header?: React.ReactNode;
    showHeader?: boolean;
    showFooter?: boolean;
    contentStyle?: React.CSSProperties;
    headerStyle?: React.CSSProperties;
    footerStyle?: React.CSSProperties;
    containerClassName?: string;
    contentClassName?: string;
    headerClassName?: string;
    footerClassName?: string;
    scrollContentToBottom?: boolean;
}

export default function FlexContainerLayout({
    children,
    footer,
    header,
    showHeader = true,
    showFooter = true,
    contentStyle,
    headerStyle,
    footerStyle,
    containerClassName = "", // For wrapping container
    contentClassName = "",
    headerClassName = "",
    footerClassName = "",
    scrollContentToBottom = false,
    ...props
}: IFlexContainerLayoutProps) {
    const contentElementRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (scrollContentToBottom) {
            if (contentElementRef.current) {
                contentElementRef.current.scrollIntoView(false);
            }
        }
    }, [scrollContentToBottom]);

    return (
        <div className={mergeClassNames("flex size-full flex-1 flex-col gap-4 overflow-auto", containerClassName)} data-testid="flex-container-layout" {...props}>
            {showHeader && !!header && (
                <div className={mergeClassNames("flex w-full", headerClassName)} style={headerStyle}>
                    {header}
                </div>
            )}
            <div ref={contentElementRef} className={mergeClassNames("scroll-webkit relative flex w-full flex-1 flex-col overflow-auto", contentClassName)} style={contentStyle}>
                {children}
            </div>
            {showFooter && !!footer && (
                <div className={mergeClassNames("flex w-full", footerClassName)} style={footerStyle}>
                    {footer}
                </div>
            )}
        </div>
    );
}
